import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "gordita-400-13 text-Text/text_medium" }
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = { class: "percent gordita-500-20-m" }
const _hoisted_6 = { class: "value gordita-400-16-r" }



import PieChartBase from '@/components/charts/pieChartBase.vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { formatNumber } from '@/services/utils';

type Section = {
  title: string;
  value: number;
  percentage?: number;
  color: string;
  dataTestId: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-performance-pie-chart',
  props: {
    sections: null
  },
  setup(__props: any) {

const props = __props as {
  sections: Section[];
}



const chartDataset = {
  datasets: [
    {
      label: props.sections.map(section => section.title),
      backgroundColor: props.sections.map(section => section.color),
      data: props.sections.map(section => section.value),
      borderWidth: 0,
    },
  ],
  options: {
    maintainAspectRatio: false,
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-performance-pie-chart flex flex-row gap-8 w-full" }, {
    default: _withCtx(() => [
      _createVNode(PieChartBase, {
        style: {"height":"120px","width":"120px","border-width":"0"},
        "chart-data": chartDataset
      }),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sections, (section) => {
          return (_openBlock(), _createElementBlock("div", {
            key: section.title,
            class: "flex flex-col items-start gap-1"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "w-2 h-2 rounded-full",
                style: _normalizeStyle({ backgroundColor: section.color })
              }, null, 4),
              _createElementVNode("div", _hoisted_3, _toDisplayString(section.title), 1)
            ]),
            _createElementVNode("div", {
              class: "flex gap-1.5 items-center",
              "data-testid": section.dataTestId
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(section.percentage) + "%", 1),
              _createElementVNode("span", _hoisted_6, "(" + _toDisplayString(_unref(formatNumber)(section.value)) + ")", 1)
            ], 8, _hoisted_4)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})